import React from 'react'
import {styledComponent} from '/app/src/hoc'

class Div extends React.Component {
    render() {
        return (
            <div className={this.props.className} onClick={this.props.onClick}>
                {this.props.children}
            </div>
        );
    }
}

const StyledDiv =  styledComponent(Div)

StyledDiv.defaultProps = {
    defaultStyle: {
    }
}

export default StyledDiv



// WEBPACK FOOTER //
// ./src/component/Div/index.js